'use strict'

class PersistentUTMs {

  constructor() {
    function persistentUTMs() {
      var queryParams = [
        'gated',
        'utm_medium', // add or remove query parameters you want to transfer
        'utm_source',
        'utm_campaign',
        'utm_content'
      ];

      var collectedQueryParams = [];
      for (var queryIndex = 0; queryIndex < queryParams.length; queryIndex++) {
        var param = getParam(queryParams[queryIndex]);
        if (param) {
          collectedQueryParams.push(queryParams[queryIndex] + '=' + param);
        }
      }

      var links = jQuery('body a');

      jQuery(links).each(function() {
        var $link = jQuery(this);
        var isInternal = true;

        if ($link[0].hostname !== window.location.hostname) {
          var lref = $link.attr('href');
          if ($link.data('no-target') !== true && (lref && !lref.indexOf('tel:') > -1 && !lref.indexOf('mailto:') > -1)) {
            $link.attr('target', '_blank');
            isInternal = false;
          }
        }

        var utmd = $link.data('utm');
        if (collectedQueryParams.length > 0 && utmd !== true && isInternal) {
          var href = $link.attr('href');
          if (href && href !== "" && href !== '#' && href.indexOf('gated') < 0 && href.indexOf('utm_source') < 0 && href.indexOf('utm_medium') < 0 && href.indexOf('utm_campaign') < 0 && href.indexOf('utm_content') < 0 ) {
            var joinIndex = (href.indexOf('?') > -1) ? '&' : '?';
            var hash = '#';

            if(href.indexOf('#') > -1) {
              hash = hash + href.split('#')[1];
              href = href.split('#')[0];
            }
            var joinIndex = (href.indexOf('?') > -1) ? '&' : '?';

            $link.attr('href', href + joinIndex + collectedQueryParams.join('&') + (hash !== '#' ? hash : '') );
            $link.attr('data-utm', 'true');
          }
        }
      });
    }

    // Mock function for getParam, replace with actual implementation
    function getParam(param) {
      var urlParams = new URLSearchParams(window.location.search);
      return urlParams.get(param);
    }

    // Apply the handleLinks function to all anchor tags with href attributes
    persistentUTMs();
  }
}